import { createContext } from "react";
import { useGetPrescriptionQuery } from "src/api/services/prescriptionsApi";
import { Prescription } from "src/api/types";

export const PrescriptionContext = createContext<Prescription | undefined>(
  undefined,
);

interface Props {
  children: React.ReactNode;
  prescriptionId: number;
}

const PrescriptionProvider = ({ children, prescriptionId }: Props) => {
  const { data, isLoading } = useGetPrescriptionQuery(prescriptionId);

  if (isLoading === true) {
    return null;
  }

  return (
    <PrescriptionContext.Provider value={data} key={data?.id}>
      {children}
    </PrescriptionContext.Provider>
  );
};

export default PrescriptionProvider;
